/* eslint-disable max-len */
import React from 'react';
import makeBodyText from '../../../utils/makeText';
const MANUAL_REVIEW_KEYS = {
    passive_contact_later: 'passive_contact_later',
    credit_freeze: 'credit_freeze',
    chex_credit_freeze: 'chex_credit_freeze',
    fraud_alert: 'fraud_alert',
    pending_screen: 'pending_screen',
    income_verification_form: 'income_verification_form',
    proof_of_income: 'proof_of_income',
    unemployment_benefits: 'unemployment_benefits',
    fraud_and_income_verification_form: 'fraud_and_income_verification_form'
};
export const MANUAL_REVIEW_TYPES = [
    MANUAL_REVIEW_KEYS.passive_contact_later,
    MANUAL_REVIEW_KEYS.credit_freeze,
    MANUAL_REVIEW_KEYS.chex_credit_freeze,
    MANUAL_REVIEW_KEYS.fraud_alert,
    MANUAL_REVIEW_KEYS.pending_screen,
    MANUAL_REVIEW_KEYS.income_verification_form,
    MANUAL_REVIEW_KEYS.proof_of_income,
    MANUAL_REVIEW_KEYS.unemployment_benefits,
    MANUAL_REVIEW_KEYS.fraud_and_income_verification_form
];
export const TYPE_DESCRIPTIONS = {
    [MANUAL_REVIEW_KEYS.passive_contact_later]: (React.createElement("span", { className: makeBodyText('L') }, "Your application is currently being reviewed. You will receive a response from us by the end of the following business day.")),
    [MANUAL_REVIEW_KEYS.credit_freeze]: (React.createElement(React.Fragment, null,
        React.createElement("span", { className: makeBodyText('L') }, "You currently have a security freeze or credit report lock on your credit report that you must temporarily lift. Please visit the same consumer reporting agency (or agencies) with which you placed the freeze or lock."),
        React.createElement("br", null),
        React.createElement("span", { className: makeBodyText('L') },
            "Once completed, please email us at ",
            React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
            " to continue your application."))),
    [MANUAL_REVIEW_KEYS.chex_credit_freeze]: (React.createElement(React.Fragment, null,
        React.createElement("span", { className: makeBodyText('L') }, "You currently have a security freeze or credit report lock on your credit report that you must temporarily lift. Please visit the same consumer reporting agency (or agencies) with which you placed the freeze or lock."),
        React.createElement("br", null),
        React.createElement("span", { className: makeBodyText('L') },
            "Once completed, please email us at ",
            React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
            " to continue your application."))),
    [MANUAL_REVIEW_KEYS.fraud_alert]: (React.createElement("span", { className: makeBodyText('L') },
        "You currently have a fraud alert on your credit report. Our Customer Support (",
        React.createElement("a", { href: 'tel:+18556465201' }, "855-646-5201"),
        " or",
        ' ',
        React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
        ") will contact you by the end of the next business day to confirm that you do intend to apply for a loan.")),
    [MANUAL_REVIEW_KEYS.pending_screen]: (React.createElement("span", { className: makeBodyText('L') },
        "Your application is pending manual review. Please email",
        ' ',
        React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
        " for further assistance.")),
    [MANUAL_REVIEW_KEYS.income_verification_form]: (until_date) => (React.createElement("span", { className: makeBodyText('L') },
        "Your application is pending. To continue, please complete the Identity Verification Form and email it to",
        ' ',
        React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
        " by ",
        until_date || 'N/A',
        ".")),
    [MANUAL_REVIEW_KEYS.proof_of_income]: (until_date) => (React.createElement("span", { className: makeBodyText('L') },
        "To continue with your application, please email",
        ' ',
        React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
        " with proof of income such as two pay stubs, benefit award letters or unemployment award letters by ",
        until_date || 'N/A',
        ".")),
    [MANUAL_REVIEW_KEYS.unemployment_benefits]: (until_date) => (React.createElement("span", { className: makeBodyText('L') },
        "Your application is pending. To continue, please complete the Unemployment Benefits Verification Form and email it to ",
        React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
        " by ",
        until_date || 'N/A',
        ".")),
    [MANUAL_REVIEW_KEYS.fraud_and_income_verification_form]: (until_date) => (React.createElement(React.Fragment, null,
        React.createElement("span", { className: makeBodyText('L') },
            "You currently have an initial or extended fraud alert on your credit report. Our Customer Support (",
            React.createElement("a", { href: 'tel:+18556465201' }, "855-646-5201"),
            " or",
            ' ',
            React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
            ") will contact you by the end of the next business day to confirm that you do intend to apply for a loan."),
        React.createElement("br", null),
        React.createElement("span", { className: makeBodyText('L') },
            "In the meantime, you must complete the Identity Verification Form and email it to",
            ' ',
            React.createElement("a", { href: 'mailto:support@creditninja.com' }, "support@creditninja.com"),
            " by ",
            until_date || 'N/A',
            ".")))
};
export const SNIPPET_BY_TYPE = {
    [MANUAL_REVIEW_KEYS.passive_contact_later]: 'Please email support@creditninja.com for further assistance.'
};
export const LINKS_BY_TYPE = {
    [MANUAL_REVIEW_KEYS.credit_freeze]: {
        label: 'Learn More About Security Freezes:',
        list: [
            {
                label: 'Experian Website',
                link: 'experian_freeze'
            },
            {
                label: 'Clarity Website',
                link: 'clarity_freeze'
            }
        ]
    },
    [MANUAL_REVIEW_KEYS.chex_credit_freeze]: {
        label: 'Learn More About Security Freezes:',
        list: [
            {
                label: 'Experian Website',
                link: 'experian_freeze'
            },
            {
                label: 'Clarity Website',
                link: 'clarity_freeze'
            },
            {
                label: 'Chex Website',
                link: 'chex'
            }
        ]
    },
    [MANUAL_REVIEW_KEYS.fraud_alert]: {
        label: 'Learn More About Fraud Alerts:',
        list: [
            {
                label: 'Experian Website',
                link: 'experian_fraud'
            },
            {
                label: 'Transunion Website',
                link: 'transunion'
            },
            {
                label: 'Equifax Website',
                link: 'equifax'
            },
            {
                label: 'Clarity Website',
                link: 'clarity_fraud'
            }
        ]
    },
    [MANUAL_REVIEW_KEYS.fraud_and_income_verification_form]: {
        label: 'Learn More About Fraud Alerts:',
        list: [
            {
                label: 'Experian Website',
                link: 'experian_fraud'
            },
            {
                label: 'Transunion Website',
                link: 'transunion'
            },
            {
                label: 'Equifax Website',
                link: 'equifax'
            },
            {
                label: 'Clarity Website',
                link: 'clarity_fraud'
            }
        ]
    }
};
export const ACTIONS_BY_TYPE = [
    MANUAL_REVIEW_KEYS.income_verification_form,
    MANUAL_REVIEW_KEYS.unemployment_benefits,
    MANUAL_REVIEW_KEYS.fraud_and_income_verification_form
];
export const ACTIONS_LINKS_BY_TYPE = (doc_links) => ({
    [MANUAL_REVIEW_KEYS.income_verification_form]: doc_links[0],
    [MANUAL_REVIEW_KEYS.unemployment_benefits]: doc_links[1],
    [MANUAL_REVIEW_KEYS.fraud_and_income_verification_form]: doc_links[0]
});
export const LINKS_URLS = {
    experian_fraud: 'https://www.experian.com/fraud/center.html',
    experian_freeze: 'https://www.experian.com/freeze/center.html',
    transunion: 'https://www.transunion.com/fraud-alerts',
    clarity_freeze: 'https://www.clarityservices.com/support/security-freeze',
    clarity_fraud: 'https://www.clarityservices.com/support/fraud-alert',
    equifax: 'https://wwww.equifax.com/personal/credit-report-services/credit-fraud-alerts',
    chex: 'https://chexsystems.com'
};
